import { OnfidoTokenDTO } from '@app/landing-videoselfing/model/videoselfing-model';
import { VideoSelfingStore } from '../landing-videoselfing/services/videoselfing.store';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'scf-finish-videoselfing',
  templateUrl: './landing-finish-videoselfing.component.html',
  styleUrls: ['./landing-finish-videoselfing.component.scss'],
})
export class LandingFinishVideoselfingComponent implements OnInit {
  constructor(private videoselfingStore: VideoSelfingStore) {}

  public applicantId: OnfidoTokenDTO;
  errorMessage: boolean;

  ngOnInit() {
    this.applicantId = this.videoselfingStore.getApplicantId();
    this.errorMessage = this.videoselfingStore.getOnfidoError();
  }
}
